/**
 * Pont panier pour les applications tierces (Replo, upsells, etc.).
 *
 * Ces apps ajoutent au panier via leurs propres appels AJAX (/cart/add.js)
 * sans connaitre les evenements du theme : le drawer ne s'ouvrait pas et le
 * compteur restait fige jusqu'au rechargement de la page.
 *
 * Ce script intercepte les mutations panier (fetch + XMLHttpRequest) et
 * rejoue les evenements natifs du theme :
 *   - "cart:refresh" -> re-rendu du drawer + mise a jour des compteurs
 *   - "variant:add"  -> ouverture du drawer (mode panier "drawer" uniquement)
 *
 * Quand la mutation vient du theme lui-meme (son "cart:change" suit toujours
 * ses propres requetes), le pont s'efface pour eviter tout double traitement.
 */
(function () {
  if (window.__almaCartBridge) {
    return;
  }
  window.__almaCartBridge = true;

  var lastThemeCartChange = 0;

  document.addEventListener('cart:change', function () {
    lastThemeCartChange = Date.now();
  });

  /**
   * Filet de securite du panier vide : la branche "item_count === 0" du
   * re-rendu du theme attend une animation (Motion) dont la promesse peut ne
   * jamais se resoudre quand elle est annulee (tiroir encore en cours
   * d'ouverture, re-rendu recent). Resultat observe : panier vide cote
   * serveur mais article toujours affiche. 700 ms apres un cart:change a
   * zero article, si l'etat vide n'est pas rendu, on fait la bascule
   * nous-memes a partir de la section deja bundlee, sans animation.
   * Idempotent : si le theme finit ensuite, il repose le meme contenu.
   */
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || cart.item_count !== 0 || !cart.sections) {
      return;
    }
    var sectionHtml = null;
    Object.keys(cart.sections).some(function (key) {
      if (key.indexOf('cart-drawer') !== -1) {
        sectionHtml = cart.sections[key];
        return true;
      }
      return false;
    });
    if (!sectionHtml) {
      return;
    }
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.querySelector('.empty-state')) {
        return; // le theme a fini son travail tout seul
      }
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var contenu = doc.querySelector('.cart-drawer');
      if (contenu) {
        drawer.replaceChildren.apply(drawer, Array.prototype.slice.call(contenu.childNodes));
      }
    }, 700);
  });

  function cartMutationPath(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(path) ? path : null;
    } catch (error) {
      return null;
    }
  }

  function notifyTheme(path) {
    setTimeout(function () {
      if (Date.now() - lastThemeCartChange < 1000) {
        return; // le theme a deja traite sa propre requete
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var settings = window.themeVariables && window.themeVariables.settings;
      if (path.indexOf('/cart/add') !== -1 && settings && settings.cartType === 'drawer') {
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true }));
      }
    }, 300);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    return originalFetch.apply(this, arguments).then(function (response) {
      if (response && response.ok) {
        var path = cartMutationPath(url);
        if (path) {
          notifyTheme(path);
        }
      }
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__almaCartPath = cartMutationPath(url || '');
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__almaCartPath) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          notifyTheme(xhr.__almaCartPath);
        }
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
